/**
 * Single place for values that are unknown until launch. Replace the PLACEHOLDER
 * values here (and nothing else) when the domain, mailbox and entity are registered.
 * index.html, robots.txt and sitemap.xml are generated from this file at build time
 * (see vite.config.ts and siteMeta.ts).
 */
export const SITE_CONFIG = {
  name: "Turnstill",
  /** PLACEHOLDER: domain not registered yet. No trailing slash. */
  origin: "https://example.com",
  /** PLACEHOLDER: mailbox not registered yet. Shown only on legal pages. */
  contactEmail: "hello@turnstill.studio",
  /** PLACEHOLDER: legal entity name, to be set when the business is formed. */
  legalEntity: "[Legal entity name]",
  /** PLACEHOLDER: governing law and venue, to be chosen with a lawyer. */
  governingLaw: "[State or country whose law governs]",
  ogImage: "/work/hero.jpg",
  /** Date the legal drafts were last edited (ISO). */
  legalUpdated: "2026-10-23",
} as const;

export type SiteConfig = typeof SITE_CONFIG;
